import React from "react"

function Clipboard({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.1 13.6V25.5C11.1 25.8 11.3 26.1 11.5 26.4C11.7 26.6 12 26.8 12.4 26.8H23.6C24 26.8 24.3 26.6 24.5 26.4C24.7 26.1 24.9 25.8 24.9 25.5V13.6C24.9 13.3 24.7 13 24.5 12.7C24.3 12.5 24 12.4 23.6 12.4H21.8"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
      <path
        d="M14.3 12.4H12.4C12 12.4 11.7 12.5 11.5 12.7C11.3 13 11.1 13.3 11.1 13.6"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
      <path
        d="M14.3 14.4H21.8V12.5C21.8 12.2 21.6 11.9 21.1 11.9H20.5C20.2 11.9 19.8 11.7 19.6 11.5C19.4 11.2 19.3 10.9 19.3 10.6C19.3 10.2 18.9 10 18.6 10H17.4C17.1 10 16.8 10.2 16.8 10.6C16.8 10.9 16.6 11.2 16.4 11.5C16.2 11.7 15.8 11.9 15.5 11.9H14.9C14.4 11.9 14.3 12.2 14.3 12.5V14.4Z"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
      <circle cx="18" cy="11.25" r="0.5" fill="#003E4C" />
      <path d="M14.3 16.8H21.8" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M14.3 19.9H21.8" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M14.3 23H18" stroke="#003E4C" strokeWidth="0.75" />
    </svg>
  )
}
export default Clipboard
